<!-- Copyright The Linux Foundation and each contributor to LFX.
SPDX-License-Identifier: MIT -->

<div class="scroll-icon" (click)="gotoTop()">
  <fa-icon [icon]="angleUpIcon"></fa-icon>
</div>
